import { createContext } from "react";

export const DigitalSignageDataContext = createContext();
